export default "__VITE_ASSET__FMKab3ed__"